// This file is used to define the environment variables for the application.
// It uses the ENV object to merge the environment variables with the process.env object.
// The ENV object is defined in the .deploy/env.json file.
// The .deploy/env.json file is created by the deploy script at deployment time.

const PROXY_URL = 'http://localhost:9090/'

/* global ENV */
const mergedEnvVars =
  typeof ENV === 'object' ? { ...process.env, ...ENV } : false

const envVars = mergedEnvVars || process.env

// Core configuration variables with renamed exports
export const {
  REACT_APP_CATALOG_API_URL: BACKEND_URL,
  REACT_APP_HORIZON_API_URL: AUTO3P_BACKEND_URL,
  REACT_APP_LOCALE: DEFAULT_LOCALE,
  REACT_APP_COUNTRY: PHONE_INPUT_COUNTRY,
  REACT_APP_CURRENCY: DEFAULT_CURRENCY,
  REACT_APP_THEME: DEFAULT_THEME,
} = envVars

// Feature flags list - add new feature flags here
export const FEATURE_FLAGS = [
  'VEHICLE_OWNER',
  'VEHICLE_USER',
  'CLAIM_DETAILS',
  'SHARE_ESTIMATE',
  'SEND_MESSAGE',
  'DRIVER_REPORT_3RD_PARTY_STAGE',
  'DRIVER_REPORT_LICENSE_STAGE',
  'OPTIONAL_ENTITIES',
  'SERVICE_SETTINGS',
  'ADDITIONAL_LABORS_LIST',
  'ADDITIONAL_SERVICE',
  'CHANGE_ESTIMATE_METHOD',
  'ESTIMATE_NOTES',
  'HIDE_SERVICE_LANGUAGE_TOGGLE',
  'HIDE_ACCOUNT_SETTINGS',
  'SERVICE_ATTACH_DOCUMENTS',
  'COMPARE_REPAIR_REPLACE',
  'DAMAGE_AREAS',
  'AUDIT_TAB',
  'QUICK_ADD_ITEMS',
  'VIN_SEARCH',
  'SHOW_GOOGLE_MAP',
]

// Feature flag constants for type-safe access (avoids magic strings)
export const FEATURES = FEATURE_FLAGS.reduce((acc, flag) => {
  acc[flag] = flag
  return acc
}, {})

// Export feature flags as an object for easy access
export const FEATURE_FLAG_VALUES = FEATURE_FLAGS.reduce((acc, flag) => {
  acc[`REACT_APP_${flag}`] =
    envVars[`REACT_APP_${flag}`] ?? process.env[`REACT_APP_${flag}`]

  return acc
}, {})

// Only use proxy URL on localhost
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1')

export const API_URL = isLocalhost
  ? `${PROXY_URL}${BACKEND_URL}/public`
  : `${BACKEND_URL}/public`
